<script setup>
import {computed, reactive} from 'vue'
import {useModalsStore} from '@/stores/modals'
import {useItemDataStore} from '@/stores/itemData'
import {useFormStore} from '@/stores/form'
import Button from '@/common/Button.vue'

const props = defineProps({
    formId: String,
    field: Object,
    modalTitle: String,
    currentData: Object,
    mode: String,
    readOnly: Boolean,
})

// Pinia Stores
const modalsStore = useModalsStore()
const itemDataStore = useItemDataStore()
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// State
const codeMirrorState = reactive({})

// Computed
const originalData = computed(() => {
    return formStore.value?.originalData
})

const tableName = computed(() => {
    return formStore.value?.tableName
})

// Methods
const onClick = () => {
    const indent = 2
    const mode = props.mode || 'text/html'

    let originalValue = originalData.value?.[props.field.name]
    if (typeof originalValue === 'object') {
        originalValue = JSON.stringify(originalValue, undefined, indent)
    }

    let value = props.currentData[props.field.name]
    if (typeof value === 'object') {
        value = JSON.stringify(value, undefined, indent)
    }

    modalsStore.show({
        componentName: 'CodeMirrorModal',
        obj: {
            formId: props.formId,
            tableName: tableName.value,
            field: props.field,
            modalTitle: props.modalTitle,
            mode: mode,
            readOnly: props.readOnly,
            originalValue: originalValue,
            currentData: props.currentData,
            value: value,
            state: codeMirrorState,
        }
    })
}

// Initialization (Equivalent to created lifecycle hook)
const init = () => {
    if (props.currentData[props.field.name] === undefined) {
        formStore.value?.presetData({
            name: props.field.name,
            value: ''
        })
    }

    // Refresh logic to prevent stale data
    if (props.currentData.id) {
        itemDataStore.get({
            tableName: tableName.value,
            id: props.currentData.id,
            refresh: true,
        }).then((obj) => {
            props.currentData[props.field.name] = obj[props.field.name]
        })
    }
}

init()
</script>

<template>
    <Button @click="onClick" class="border">
        {{ field.buttonText || 'Edit' }}
    </Button>
</template>